import { useEffect, useState } from 'react';
import { calculateTextExprValue, executeFunction } from '../util/util';
import { makeChartRequestConfig, makeRequest } from '../request';
import { BaseLowCodeProps, DataOriginType, PagingProps } from '@/lowcode/common/types';
import { getAggregationConfig } from '../setter/util';
import { getRealData } from '../request/requestUtil';

export function useData({ config, source }: { config: BaseLowCodeProps; source?: string }) {
  const [data, setData] = useState<any[] | null>(null);
  const [paging, setPaging] = useState<PagingProps | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const { dataFrom, _context, isDesign } = config || {};
  const { dataOrigin, dataSource, requestConfig } = dataFrom || {};

  const getRealRequestConfig = () => {
    if (source === 'chart') {
      const sorts = config?.sorts?.filter((item) => Boolean(item.order));

      return makeChartRequestConfig({
        ...config,
        sorts,
        aggregationConfig: getAggregationConfig(config.dataFrom?.requestConfig?.metaConfig, {
          tableSorts: sorts,
        }),
      });
    }

    return {
      isDesign,
      needSuccessToast: false,
      buttonConfig: {
        options: {
          requestConfig,
        },
      },
      recordDataSource: {},
      state: _context?.state || {},
    };
  };

  const refreshData = async () => {
    if (
      requestConfig?.execute &&
      executeFunction(requestConfig.execute, config, _context?.state) === false
    ) {
      return;
    }

    if (dataOrigin === DataOriginType.static) {
      return calculateTextExprValue(dataSource, {
        recordDataSource: {},
        state: _context?.state,
      });
    }
    if (
      dataOrigin === DataOriginType.request ||
      requestConfig?.serviceType === DataOriginType.dataeasy ||
      (isDesign && requestConfig?.__serviceType__ === 'datasource')
    ) {
      const realRequestConfig = getRealRequestConfig();
      setLoading(true);
      makeRequest<typeof data>(realRequestConfig)
        .then((res) => {
          if (source === 'chart') {
            const realData = getRealData(realRequestConfig, res, _context);
            setData(realData?.records);
            setPaging(realData?.paging);
            return;
          }

          setData(res?.data);
        })
        .catch((err) => {
          setError(err);
          return undefined;
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (isDesign) {
      if (dataFrom?.dataOrigin === DataOriginType.static) {
        refreshData();
      }
    }
  }, [dataFrom?.dataSource]);

  return {
    data,
    paging,
    error,
    loading,
    refreshData,
  };
}
